import * as React from 'react';

import {ButtonGroup} from 'shells/button-group/button-group';

import type {
    EditionFragment as DripEdition,
    SmsDripEditionFragment as SmsDripEdition,
    SmsDripSequenceFragment as SmsDripSequence,
    DripSequenceFragment as DripSequence,
} from 'nutshell-graphql-types';

import {ActivateSequenceButton as SmsActivateSequenceButton} from '../../sms/drip-sequences/drip-sequence-page/activate-sequence-button';

import {ActivateSequenceButton} from './activate-sequence-button';
import {CancelSequenceButton} from './cancel-sequence-button';
import {PauseSequenceButton} from './pause-sequence-button';
import {ResumeSequenceButton} from './resume-sequence-button';

type Props = {
    isLoading: boolean;
    editions: DripEdition[] | SmsDripEdition[];
    dripSequence: SmsDripSequence | DripSequence | null | undefined;
    refetchDripSequence: () => Promise<any>;
    refetchDripEditions: () => Promise<any>;
};

export function ControlButtons(props: Props) {
    return (
        <ButtonGroup>
            {props.dripSequence && props.dripSequence.status === 'DRAFT' && (
                <>
                    {props.dripSequence.__typename === 'SmsCampaign' ? (
                        <SmsActivateSequenceButton
                            isDisabled={props.isLoading || props.editions.length === 0}
                            dripSequence={props.dripSequence}
                            // @ts-expect-error
                            editions={props.editions}
                        />
                    ) : (
                        <ActivateSequenceButton
                            buttonText='Activate sequence'
                            disabled={props.isLoading || props.editions.length === 0}
                            // @ts-expect-error
                            editions={props.editions}
                            dripSequence={props.dripSequence}
                            onActivated={() => {
                                props.refetchDripSequence();
                                props.refetchDripEditions();
                            }}
                        />
                    )}
                </>
            )}
            {props.dripSequence && props.dripSequence.status === 'ACTIVE' && (
                <PauseSequenceButton
                    disabled={props.isLoading}
                    dripSequenceId={props.dripSequence.id}
                    onPaused={() => {
                        props.refetchDripSequence();
                        props.refetchDripEditions();
                    }}
                />
            )}
            {props.dripSequence && props.dripSequence.status === 'PAUSED' && (
                <>
                    <CancelSequenceButton
                        disabled={props.isLoading}
                        dripSequenceId={props.dripSequence.id}
                        recipientCount={props.dripSequence.numInProgressDripProgressions}
                        onCanceled={() => {
                            props.refetchDripSequence();
                            props.refetchDripEditions();
                        }}
                    />
                    <ResumeSequenceButton
                        disabled={props.isLoading}
                        dripSequence={props.dripSequence}
                        onResumed={() => {
                            props.refetchDripSequence();
                            props.refetchDripEditions();
                        }}
                    />
                </>
            )}
            {props.dripSequence && props.dripSequence.status === 'PROBLEM' && (
                <>
                    <CancelSequenceButton
                        disabled={props.isLoading}
                        dripSequenceId={props.dripSequence.id}
                        recipientCount={props.dripSequence.numInProgressDripProgressions}
                        onCanceled={() => {
                            props.refetchDripSequence();
                            props.refetchDripEditions();
                        }}
                    />
                    {props.dripSequence.__typename === 'SmsCampaign' ? (
                        <SmsActivateSequenceButton
                            isDisabled={props.isLoading || props.editions.length === 0}
                            dripSequence={props.dripSequence}
                            // @ts-expect-error
                            editions={props.dripSequence.editions}
                        />
                    ) : (
                        <ActivateSequenceButton
                            buttonText='Activate sequence'
                            disabled={props.isLoading || props.editions.length === 0}
                            // @ts-expect-error
                            editions={props.editions}
                            dripSequence={props.dripSequence}
                            onActivated={() => {
                                props.refetchDripSequence();
                                props.refetchDripEditions();
                            }}
                        />
                    )}
                </>
            )}
            {props.dripSequence && props.dripSequence.status === 'RETIRED' && (
                <CancelSequenceButton
                    disabled={props.isLoading}
                    dripSequenceId={props.dripSequence.id}
                    recipientCount={props.dripSequence.numInProgressDripProgressions}
                    onCanceled={() => {
                        props.refetchDripSequence();
                        props.refetchDripEditions();
                    }}
                    isCancelOnly={true}
                />
            )}
        </ButtonGroup>
    );
}
